import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-select",
  templateUrl: "./select.component.html",
  styleUrls: ["./select.component.scss"],
})
export class SelectComponent implements OnInit, OnChanges {
  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {}

  @Input() options: any = [];
  @Output() handleSelection: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedItem: any = {};

  onSelectChange(event: any): void {
    this.handleSelection.emit(event);
  }
}
